<footer class="footer ">
  <div class="container-fluid">
    <div class="copyright ">
      {{test | date: 'yyyy'}} &copy; VIQ Solutions, Inc.    Version {{ versionNumber }}, [ {{ buildVersion }} ]
      <!-- <a href="https://devnswconn.aiassist.ai/login" target="_blank">VIQ Solutions, Inc.</a>  -->
    </div>
  </div>
</footer>